/* HOME-9 — reveal on scroll + counters. Failsafe: si algo falla, todo queda visible. */
(function () {
  'use strict';
  // marca que hay JS (activa el opacity:0 del reveal solo ahora → sin pantalla blanca si el JS no corre)
  document.documentElement.classList.add('h9-js');

  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  ready(function(){
    var reveals = document.querySelectorAll('.h9-reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
      }, { threshold:0.12, rootMargin:'0px 0px -40px 0px' });
      reveals.forEach(function(el){ obs.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add('is-visible'); });
    }

    // contadores
    function animate(el){
      var target = parseFloat(el.dataset.target), suffix = el.dataset.suffix||'', prefix = el.dataset.prefix||'';
      var dec = (target % 1 !== 0) ? 1 : 0, dur = 1600, start = null;
      function step(ts){ if(!start) start=ts; var p=Math.min((ts-start)/dur,1); var e=1-Math.pow(1-p,3);
        el.textContent = prefix + (e*target).toFixed(dec) + suffix; if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    var nums = document.querySelectorAll('.h9-stat__num[data-target]');
    if ('IntersectionObserver' in window && nums.length) {
      var so = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ animate(e.target); so.unobserve(e.target); } });
      }, { threshold:0.6 });
      nums.forEach(function(el){ so.observe(el); });
    } else {
      nums.forEach(function(el){ el.textContent = (el.dataset.prefix||'') + el.dataset.target + (el.dataset.suffix||''); });
    }

    // FAQ: cerrar las demás al abrir una
    document.querySelectorAll('.h9-faq__item').forEach(function(item){
      item.addEventListener('toggle', function(){
        if(item.open) document.querySelectorAll('.h9-faq__item').forEach(function(o){ if(o!==item) o.open=false; });
      });
    });
  });
})();
